import type { LiveBreakHost, LiveSlotHost } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import type { ShareTarget } from "../../core/primitives/share-links";

export class LiveBreakState {
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly breakRow = new Rx<LiveBreakHost | null>(null);
  readonly slots = new RxList<LiveSlotHost>();
  readonly title = new Rx("");
  readonly saveTitle = new Rx<FormStatus>(idleForm);
  /** The break time as typed, a `datetime-local` value; empty is any time. */
  readonly breakTime = new Rx("");
  readonly saveBreakTime = new Rx<FormStatus>(idleForm);
  readonly cover = new Rx<FormStatus>(idleForm);
  /** Cancelling asks first; this is the second tap waiting. */
  readonly confirmCancel = new Rx(false);
  readonly cancel = new Rx<FormStatus>(idleForm);
  readonly promote = new Rx<FormStatus>(idleForm);
  /** The break's public page, once buyers can see it. */
  readonly share = new Rx<ShareTarget | null>(null);
}

export abstract class LiveBreakActions {
  abstract setTitle(value: string): void;
  abstract saveTitle(): Promise<void>;
  abstract setBreakTime(value: string): void;
  /** Once spots sell: later freely, earlier only to two hours out, never cleared; the server says which. */
  abstract saveBreakTime(): Promise<void>;
  abstract uploadCover(file: File): Promise<void>;
  abstract reload(): Promise<void>;
  /** First call asks, the second cancels; `keepBreak` backs out. */
  abstract cancelBreak(): Promise<void>;
  abstract keepBreak(): void;
  /** One push to every phone that the box still has spots; once a day. */
  abstract promote(): Promise<void>;
}
